import { render, staticRenderFns } from "./QuotationEditPage.vue?vue&type=template&id=58835406&scoped=true"
import script from "./QuotationEditPage.vue?vue&type=script&lang=js"
export * from "./QuotationEditPage.vue?vue&type=script&lang=js"
import style0 from "./QuotationEditPage.vue?vue&type=style&index=0&id=58835406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58835406",
  null
  
)

export default component.exports